import React from 'react';
import FAQ from './FAQ';

function App() {
  return (
    <div className="p-10">
      <FAQ />
    </div>
  );
}

export default App;

